import LectureLessonHistoryListPagingResultModelBase from '../_generated/modelBases/lecture-lesson-history-list-paging-result-model-base';

export default class LectureLessonHistoryListPagingResultModel extends LectureLessonHistoryListPagingResultModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
